import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    genericTitle: string;
    genericSubtitle: string;
    genericSuccessMessage: string;
    genericErrorMessage: string;
    transcriptionFeedbackTitle: string;
    transcriptionFeedbackSubtitle: string;
    transcriptionFeedbackSuccessMessage: string;
    transcriptionFeedbackErrorMessage: string;
    searchFeedbackTitle: string;
    searchFeedbackSubtitle: string;
    searchFeedbackSuccessMessage: string;
    searchFeedbackErrorMessage: string;
    integrationsFeedbackTitle: string;
    integrationsFeedbackSubtitle: string;
    integrationsFeedbackSuccessMessage: string;
    integrationsFeedbackErrorMessage: string;
    webhooksFeedbackTitle: string;
    webhooksFeedbackSubtitle: string;
    webhooksFeedbackSuccessMessage: string;
    webhooksFeedbackErrorMessage: string;
    actionsFeedbackTitle: string;
    actionsFeedbackSubtitle: string;
    actionsFeedbackSuccessMessage: string;
    actionsFeedbackErrorMessage: string;
    chatFeedbackTitle: string;
    chatFeedbackSubtitle: string;
    chatFeedbackSuccessMessage: string;
    chatFeedbackErrorMessage: string;
    sharedSummaryRequired: string;
    sharedDescriptionRequired: string;
    sharedSubmitButton: string;
    sharedCancelButton: string;
    sharedSummaryError: string;
    dialogCloseLabel: string;
    driveFeedbackTitle: string;
    driveFeedbackSubtitle: string;
    driveFeedbackSuccessMessage: string;
    driveFeedbackErrorMessage: string;
    fireflyActionsFeedbackTitle: string;
    fireflyActionsFeedbackSubtitle: string;
    fireflyActionsFeedbackSuccessMessage: string;
    fireflyActionsFeedbackErrorMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title for generic feedback submission */
            genericTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.genericTitle?c=5adg65suwfs8", defaultMessage: "Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share generic feedback */
            genericSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.genericSubtitle?c=j8yqfb5q75uk", defaultMessage: "We''d love to hear how Frame.io is working for you, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when generic feedback is submitted */
            genericSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.genericSuccessMessage?c=25und4tlpgrij", defaultMessage: "Feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when generic feedback submission fails */
            genericErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.genericErrorMessage?c=jowh0m9l3a2f", defaultMessage: "Sorry, your feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for transcription feedback submission */
            transcriptionFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.transcriptionFeedbackTitle?c=2um4hriz67fop", defaultMessage: "Transcription Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share transcription feedback */
            transcriptionFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.transcriptionFeedbackSubtitle?c=3026pqj1fcene", defaultMessage: "We''d love to hear what you think about the transcription feature, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when transcription feedback is submitted */
            transcriptionFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.transcriptionFeedbackSuccessMessage?c=2j89g42tdk2wu", defaultMessage: "Transcription feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when transcription feedback submission fails */
            transcriptionFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.transcriptionFeedbackErrorMessage?c=7zc54hzwfdjj", defaultMessage: "Sorry, your transcription feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for search feedback submission */
            searchFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.searchFeedbackTitle?c=2h25j56t15xb9", defaultMessage: "Share Feedback on Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share search feedback */
            searchFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.searchFeedbackSubtitle?c=2oagx6g0e5q53", defaultMessage: "We''d love to hear what you think about search, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when search feedback is submitted */
            searchFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.searchFeedbackSuccessMessage?c=2tsj2yu24fbwn", defaultMessage: "Search feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when search feedback submission fails */
            searchFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.searchFeedbackErrorMessage?c=1c1vtxsdunbub", defaultMessage: "Sorry, your search feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for integrations feedback submission */
            integrationsFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.integrationsFeedbackTitle?c=5adg65suwfs8", defaultMessage: "Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share Frame.io Panel feedback */
            integrationsFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.integrationsFeedbackSubtitle?c=1acpr8xc09n4d", defaultMessage: "We''d love to hear what you think about the Frame.io Panel, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when integration feedback is submitted */
            integrationsFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.integrationsFeedbackSuccessMessage?c=2hn9o807hmfz2", defaultMessage: "Frame.io V4 (Beta) feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when integration feedback submission fails */
            integrationsFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.integrationsFeedbackErrorMessage?c=4mwjf46njtlw", defaultMessage: "Sorry, your Frame.io V4 (Beta) feedback wasn''t submitted due to an error." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for webhooks feedback submission */
            webhooksFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.webhooksFeedbackTitle?c=e6xkz7z45c6w", defaultMessage: "Webhooks Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share webhooks feedback */
            webhooksFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.webhooksFeedbackSubtitle?c=3lzsgpw0dgfh0", defaultMessage: "We''d love to hear what you think about webhooks, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when webhooks feedback is submitted */
            webhooksFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.webhooksFeedbackSuccessMessage?c=347x3ic490dbb", defaultMessage: "Webhooks feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when webhooks feedback submission fails */
            webhooksFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.webhooksFeedbackErrorMessage?c=1j6sjkizztany", defaultMessage: "Sorry, your webhooks feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for actions feedback submission */
            actionsFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.actionsFeedbackTitle?c=1hcibh7636e73", defaultMessage: "Actions Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share actions feedback */
            actionsFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.actionsFeedbackSubtitle?c=61mdsvg0h6fl", defaultMessage: "We''d love to hear what you think actions, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when actions feedback is submitted */
            actionsFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.actionsFeedbackSuccessMessage?c=1fyaegm9ce033", defaultMessage: "Actions feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when actions feedback submission fails */
            actionsFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.actionsFeedbackErrorMessage?c=908oi7m8bajw", defaultMessage: "Sorry, your actions feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for chat feedback submission */
            chatFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.chatFeedbackTitle?c=1lm57otefe730", defaultMessage: "AI Assistant feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share AI Assistant feedback */
            chatFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.chatFeedbackSubtitle?c=vbn9bchkyz50", defaultMessage: "We\u2019d love to hear what you think about the AI Assistant, and if there\u2019s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when chat feedback is submitted */
            chatFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.chatFeedbackSuccessMessage?c=3no435ed3f2w7", defaultMessage: "AI Assistant feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when chat feedback submission fails */
            chatFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.chatFeedbackErrorMessage?c=3h5gcqqqpixe0", defaultMessage: "Sorry, your AI Assistant feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for required summary field in feedback form */
            sharedSummaryRequired: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.sharedSummaryRequired?c=2om4jv26shr3m", defaultMessage: "Summary (required)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for required description field in feedback form */
            sharedDescriptionRequired: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.sharedDescriptionRequired?c=2s25ii4f5tfkw", defaultMessage: "Description (required)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to submit feedback form */
            sharedSubmitButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.sharedSubmitButton?c=3oyrpob9pgu4z", defaultMessage: "Submit" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to cancel and close feedback dialog */
            sharedCancelButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.sharedCancelButton?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when summary field is empty */
            sharedSummaryError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.sharedSummaryError?c=32lwz0kcaf2tq", defaultMessage: "Summary is required" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for dialog close button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for drive feedback submission */
            driveFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.driveFeedbackTitle?c=zm4y131x714l", defaultMessage: "Submit feedback for Drive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share drive feedback feedback */
            driveFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.driveFeedbackSubtitle?c=27kgmievrg6jk", defaultMessage: "We''d love to hear how Frame.io Drive is working for you, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when drive feedback is submitted */
            driveFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.driveFeedbackSuccessMessage?c=1brg85zjvbs1u", defaultMessage: "Drive feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when drive feedback submission fails */
            driveFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.driveFeedbackErrorMessage?c=peun4ffuyig4", defaultMessage: "Sorry, your Drive feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for Firefly Actions feedback submission */
            fireflyActionsFeedbackTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.fireflyActionsFeedbackTitle?c=2lac4ofbkcbxm", defaultMessage: "Submit Firefly Actions Feedback" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle prompting user to share Firefly Actions feedback */
            fireflyActionsFeedbackSubtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.fireflyActionsFeedbackSubtitle?c=10sh54b5nlj1e", defaultMessage: "We''d love to hear what you think about Firefly Actions, and if there''s anything we can do to improve your experience." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when Firefly Actions feedback is submitted */
            fireflyActionsFeedbackSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.fireflyActionsFeedbackSuccessMessage?c=1hlk2piqrqr9r", defaultMessage: "Firefly Actions feedback submitted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when Firefly Actions feedback submission fails */
            fireflyActionsFeedbackErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FeedbackDialog.fireflyActionsFeedbackErrorMessage?c=28ybol38dpg4s", defaultMessage: "Sorry, your Firefly Actions feedback wasn''t submitted due to an error. Please contact us via the Contact Support button for help." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
